var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNewPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93106 0.0859375C6.18736 0.0859375 6.39917 0.276294 6.43272 0.523392L6.43738 0.592086L6.43819 5.48594L11.334 5.48594C11.6136 5.48594 11.8403 5.7126 11.8403 5.99219C11.8403 6.24849 11.6498 6.4603 11.4027 6.49385L11.334 6.49844L6.43819 6.49844L6.4396 11.3916C6.4396 11.6712 6.21301 11.898 5.93342 11.898C5.67712 11.898 5.46531 11.7076 5.43169 11.4605L5.4271 11.3918L5.42569 6.49844H0.532617C0.253025 6.49844 0.0263672 6.27177 0.0263672 5.99219C0.0263672 5.73589 0.216825 5.52408 0.463923 5.49053L0.532617 5.48594H5.42569L5.42488 0.592289C5.42481 0.312697 5.65141 0.0859375 5.93106 0.0859375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewPlayer);
export default __webpack_public_path__ + "static/media/add-new-player.c0c760087e0501fe42c692beb0d4f8f1.svg";
export { ForwardRef as ReactComponent };